import { useIdSeed } from '@atlaskit/ds-lib/use-id';

/**
 * Generates unique ID.
 */
export default function useUniqueId(prefix, shouldRenderId) {
  var seed = useIdSeed();
  return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}